module.exports = __webpack_public_path__ + "static/media/thank.1f37ba2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thank.mp3
// module id = mjfo
// module chunks = 1